import { useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ConfigProvider, Spin, Form } from 'antd'
import { Typography, Button, TextArea, Input, ConfirmModal } from 'mobily-ui-library/lib'

import Location from '../../assets/MyLocation.svg'
import ArrowLeft from '../../assets/ArrowLeft.svg'
import ArrowRight from '../../assets/ArrowRight.svg'

import Map from './Map/Map'
import MapModal from './MapModal/MapModal'
import { useWindowSize } from '../Util/WindowResize'
import { GlobalContext } from '../../context/GlobalContext'
import { deliveryAddressChange } from '../../api/api'
import './DeliveryDetails.scss'

const DeliveryDetails = () => {
  const { t } = useTranslation()
  const [state, dispatch]: any = useContext(GlobalContext)
  const { rtl, inquiryRes, hashCode, selectedOrderDetails, googleMapsLoaded } = state

  const direction = rtl ? 'rtl' : 'ltr'
  const dir = rtl ? 'right' : 'left'
  const win: any = window
  var serverURL = win['base_portal_url']
  var errorPage = win['errorPageURL']

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [validationStatus, setValidationStatus] = useState(false)
  const [form] = Form.useForm()
  const [width] = useWindowSize()

  let inquiryResData: any = selectedOrderDetails === '' ? inquiryRes.orders : selectedOrderDetails
  const orderNum = inquiryResData[0].orderInfo.OrderNumber
  const tookenId = inquiryResData[0].orderInfo.TookanID
  let deliveryAddress =
    inquiryResData[0].orderInfo.DeliveryAddress === 'NA'
      ? 'Riyadh'
      : inquiryResData[0].orderInfo.DeliveryAddress
  // const deliveryAddress = 'JHYA3712, 3712 Prince Naif Rd, 8067، حي الشراع، Jeddah 23816, Saudi Arabia';
  const deliveryNotes =
    inquiryResData[0].orderInfo.DeliveryNote === 'NA'
      ? ''
      : inquiryResData[0].orderInfo.DeliveryNote
  const [address, setAddress] = useState<any>({})
  const [mapModal, setMapModal] = useState(false)
  const [isReciverAddressFieldVisible, setIsReciverAddressFieldVisible] = useState(true)
  const [reciverAddress, setReciverAddress] = useState(deliveryAddress)
  const [reciverNotes, setReciverNotes] = useState(deliveryNotes)
  // const [latLng, setLatLng] = useState({ lat: 21.3890824, lng: 39.8579118 });

  const handleAddress = (value: any, address: any) => {
    address === undefined ? setValidationStatus(false) : setValidationStatus(true)
    setAddress(address)
    setReciverAddress(value)
    form.setFieldsValue({
      deliveryAddress: value,
    })
  }

  const handleLocation = (value: boolean) => {
    if (value) {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
      setMapModal(value)
      form.resetFields()
      setReciverAddress('')
    } else {
      setMapModal(value)
    }
    console.log(mapModal)
  }

  const handleDeliveryNotes = (e: any) => {
    const value = e.target.value
    setReciverNotes(value)
  }

  const submitForm = () => {
    deliveryAddressChange(
      orderNum,
      reciverAddress,
      deliveryNotes,
      address.lat,
      address.lng,
      tookenId,
      hashCode
    ).then((response: any) => {
      if (response.status === 200) {
        if (response.data.StatusCode === '0000') {
          dispatch({
            type: 'DELIVERY_DETAILS_SUCCESS',
            payload: {
              changesSaved: 'true',
              changedAddress: reciverAddress,
              changedNotes: reciverNotes,
            },
          })
          dispatch({ type: 'GO_TO_SCREEN', payload: { page: 'OrderDetails' } })
        } else {
           // go to generic error
        window.location.href = serverURL + errorPage + `?errorSource= ${t('ecommerce')}`
        }
      } else {
        // go to generic error
        window.location.href = serverURL + errorPage + `?errorSource= ${t('ecommerce')}`
      }
    })
  }

  const handleCancelEditingBtn = () =>
    dispatch({ type: 'GO_TO_SCREEN', payload: { page: 'OrderDetails' } })

  return (
    <div className="deliveryDetails_order_container">
      <Typography className="deliveryDetails_back_button">
        <div>
          {dir === 'right' ? (
            <img style={{ height: '16px' }} src={ArrowRight} alt="arrowRight" />
          ) : (
            <img style={{ height: '16px' }} src={ArrowLeft} alt="arrowLeft" />
          )}
        </div>
        <Button rtl={rtl} onClick={() => setIsModalVisible(true)}>
          {t('back')}
        </Button>
      </Typography>

      <div className="deliveryDetails_title_container">
        <Typography className="deliveryDetails_title">{t('delivery_details_title')}</Typography>
      </div>

      {!googleMapsLoaded && <Spin className="spinLoader" size="large" />}

      <div className="deliveryDetails_form_container">
        <ConfigProvider direction={direction}>
          <Form form={form} name="control-ref">
            <div className="deliveryDetails_form_items">
              <div className="deliveryDetails_map">
                {width > 650 ? (
                  <Form.Item
                    hasFeedback
                    validateStatus={validationStatus ? 'success' : ''}
                    name="deliveryAddress"
                    className="form_fieldItem .deliveryDetails_map"
                    rules={[
                      {
                        required: true,
                        message: t('Delivery_Address'),
                      },
                    ]}
                  >
                    <Map
                      rtl={rtl}
                      handleAddress={handleAddress}
                      placeholder={t('address')}
                      headingleft={t('address')}
                      mapValue={reciverAddress}
                      address={reciverAddress}
                    />
                  </Form.Item>
                ) : (
                  <Form.Item
                    hasFeedback
                    initialValue={reciverAddress}
                    name="deliveryAddress"
                    className="form_fieldItem"
                    rules={[
                      {
                        required: true,
                        message: t('Delivery_Address'),
                      },
                    ]}
                  >
                    <Input
                      readOnly
                      placeholder={t('Delivery_Address')}
                      headingleft={t('Delivery_Address')}
                      value={reciverAddress}
                      rtl={rtl}
                      suffix={
                        <img src={Location} alt="location" onClick={() => handleLocation(true)} />
                      }
                    />
                  </Form.Item>
                )}
              </div>
              <div className="deliveryDetails_notes">
                {(googleMapsLoaded || width < 650) && (
                  <Form.Item
                    initialValue={reciverNotes}
                    className="form_fieldItem"
                    name="deliveryNotes"
                    rules={[{ required: false, message: 'Delivery Notes' }]}
                  >
                    <TextArea
                      rtl={rtl}
                      value={reciverNotes}
                      placeholder={t('type_your_notes')}
                      onChange={handleDeliveryNotes}
                      headingleft={t('delivery_notes')}
                      headingright={t('optional')}
                      labelleft={t('anything_we_should_know')}
                      className="deliveryNotes_TextField"
                    />
                  </Form.Item>
                )}
              </div>
              {mapModal && (
                <MapModal
                  isReciverAddressFieldVisible={isReciverAddressFieldVisible}
                  handleAddress={handleAddress}
                  rtl={rtl}
                  loadCurrLoc={true}
                  placeholder={t('Delivery_Address')}
                  headingleft=""
                  labelleft="1"
                  mapValue={reciverAddress}
                  handleLocation={handleLocation}
                />
              )}
            </div>

            {(googleMapsLoaded || width < 650) && (
              <Form.Item>
                <div className="deliveryDetails_save_button">
                  <Button rtl={rtl} primary={true} onClick={submitForm} htmlType={'submit'}>
                    {t('save_changes')}
                  </Button>
                </div>
              </Form.Item>
            )}
          </Form>
        </ConfigProvider>
      </div>
      <ConfirmModal
        title={t('deliveryDetails_title')}
        subText={t('deliveryDetails_subtitle')}
        buttonName={t('keep_editing')}
        outlineButtonName={t('cancel_editing')}
        showModal={isModalVisible}
        onClickClose={() => setIsModalVisible(false)}
        onclickButton={() => setIsModalVisible(false)}
        onclickOutLineButton={handleCancelEditingBtn}
      />
    </div>
  )
}

export default DeliveryDetails
